import React from "react";
import { CountrySelect } from "./CountrySelect";

/* The dial-code picker inside a phone field, as the SAME menu every other country field uses. */
export const PhoneCountrySelect = ({ value, onChange, disabled, readOnly }) => (
  <CountrySelect
    variant="bar"
    size="sm"
    value={value}
    /* CountrySelect hands back the whole country; the phone input wants its
       ISO-2 code. */
    onChange={(country) => onChange?.(country?.code)}
    disabled={Boolean(disabled || readOnly)}
    /* Flag and chevron only — the number needs the room. */
    nameClassName="hidden"
    /* Named for what it picks, so it is distinguishable from the dialog's own
       Country or Nationality field. */
    ariaLabel="Dial code"
    placeholder="Country"
  />
);

export default PhoneCountrySelect;
